import * as React from 'react'
import {
  Grid,
  Typography,
  Box,
  useMediaQuery,
  useTheme,
  Link,
  Divider
} from '@mui/material';
import twitter from '../images/twitter.png';
import youtube from '../images/youTube.png';
import fb from '../images/fb.png';
import Logo from '../images/logo.png';
import TextSmall from './TextSmall';
import { topics } from '../const/const';
import { navigate } from 'gatsby';

const Footer = () => {

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
  const isLargeTablet = useMediaQuery(theme.breakpoints.between('md', 'lg'));
  const isDesktop = useMediaQuery(theme.breakpoints.between('lg', 'xl'));
  const isXLDesktop = !isMobile && !isTablet && !isLargeTablet && !isDesktop;

  const links = [
    { label: "Sex & Relationships", href: "#" },
    { label: "Pregnancy & Contraception", href: "#" },
    { label: "Gender Identity & Sexual Orientation", href: "#" },
    { label: "Health & Wellness", href: "#" },
    { label: "Sexually Transmitted Infection/Diseases", href: "#" },
  ];

  const handleTopicClick = (color, link) => {
    navigate(link, {
      state: { color }, // Pass the color to the next page
    });
  };

  return (
    <div style={{
      padding: isMobile ? '5%' : isTablet ? '2rem 2rem 1rem 2rem' : isLargeTablet ? '2rem 2rem 1rem 2rem' : isDesktop ? '2rem 2rem 1rem 2rem' : '2.5rem 11rem 1.5rem 11rem',
      fontSize: '16px'
    }}>


      <Grid
        container
        justifyContent="center" // Horizontally center on desktop
        spacing={isXLDesktop ? 2 : 1} // Space between items
        sx={{
          paddingX: isXLDesktop ? 2 : 0,
          width: "100%",
        }}
        mb={isMobile ? 5 : 8}
      >
        {topics.map((link, index) => (
          <Grid
            item
            key={index}
            xs={12}
            sm="auto"
            sx={{
              textAlign: isMobile ? "left" : "center",
            }}
          >
            <Link
              onClick={() => handleTopicClick(link.color, link.link)}
              underline="none"
              sx={{
                display: "block",
                width: "100%",
                padding: "0.5rem",
                cursor: 'pointer',
                paddingLeft: isMobile ? "0rem" : ""
              }}
            >
              <TextSmall content={link.topic} color="#000000" />
            </Link>
          </Grid>
        ))}
      </Grid>

      <Box onClick={() => navigate('/')}><img src={Logo} className='logo-style' alt="Logo" style={{ marginBottom: '0.6rem', cursor: 'pointer' }} /></Box>

      <Grid container spacing={2} mt={-1} mb={4}>
        <Grid item xs={12} sm={6} md={6} lg={6}>
          <Box>
            <TextSmall content=" Happy Life is your trusted online companion for navigating the complexities of youth. We provide accurate,
            up-to-date, and age-appropriate information on sex, relationships, health, and identity. Our goal is to
            empower young people with the knowledge and confidence to make informed decisions and build a happy, healthy
            future." color="#555555" />
          </Box>
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={6}>
          <Grid container spacing={0}>

            <Grid item xs={12} sx={{
              '&.MuiGrid-root': {
                marginTop: isMobile ? '1rem' : '',
                paddingLeft: isLargeTablet ? '2rem' : '',
                textAlign: !isMobile ? 'right' : '',
              }
            }}>
              <Link color="inherit" underline="none" mr={3}
                style={{
                  width: isMobile ? '100%' : '',
                  marginBottom: isMobile ? '0.6rem' : isLargeTablet ? '0.8rem' : '',
                  cursor: 'pointer'
                }} onClick={() => navigate('/AboutUs')}>
                <TextSmall content="About Us" color="#000000" />
              </Link>
              <Link color="inherit" underline="none"
                style={{
                  width: isMobile ? '100%' : '',
                  marginBottom: isMobile ? '0.6rem' : isLargeTablet ? '0.8rem' : '',
                  cursor: 'pointer'
                }} onClick={() => navigate('/ContactUs')}>
                <TextSmall content="Contact Us" color="#000000" />
              </Link>
            </Grid>

            <Grid item xs={12} sx={{
              '&.MuiGrid-root': {
                marginTop: isMobile ? '1rem' : '',
                paddingLeft: isLargeTablet ? '2rem' : '',
                textAlign: !isMobile ? 'right' : '',
                mt: 2
              }
            }}>
              <Link color="inherit" underline="none" href="tel:+94765884881" sx={{cursor: "pointer"}}>
              <Typography className='small-text' sx={{ 
      '&.MuiTypography-root': {
        display: 'inline',
        color: '#000000',
      }
     }}>
    +94 76 588 4881
  </Typography>
              </Link>
            </Grid>

            <Grid item xs={12} sx={{
              '&.MuiGrid-root': {
                marginTop: isMobile ? '0.2rem' : '',
                paddingLeft: isLargeTablet ? '2rem' : '',
                textAlign: !isMobile ? 'right' : '',
              }
            }}>
              <Link color="inherit" underline="none" href="tel:+94112555455"
                sx={{
                  width: isMobile ? '100%' : '',
                  marginBottom: isMobile ? '0.6rem' : isLargeTablet ? '0.8rem' : isDesktop ? '1rem' : '',
                  cursor: 'pointer',
                }}>
                <TextSmall content="+94 11 2 555 455" color="#000000" />
              </Link>
              <span> / </span>
              <Link color="inherit" underline="none" href="tel:+94112588488"
                sx={{
                  width: isMobile ? '100%' : '',
                  marginBottom: isMobile ? '0.6rem' : isLargeTablet ? '0.8rem' : isDesktop ? '1rem' : '',
                  cursor: 'pointer',
                }}>
                <TextSmall content="+94 11 2 588 488" color="#000000" />
              </Link>
            </Grid>

            <Grid item xs={12} sx={{ textAlign: isDesktop ? 'right' : '' }}>
              <Box sx={{
                '&.MuiBox-root': {
                  marginTop: '1.5rem',
                  width: isXLDesktop ? '28%' : isDesktop ? '48%' : isLargeTablet ? '60%' : isTablet ? '50%' : '100%',
                  float: !isMobile ? 'right' : '',
                  textAlign: !isMobile ? 'right' : ''
                }
              }}>
                {/* <Link href="#" color="inherit" underline="none" mr={3}>
                  <img src={twitter} alt="twitter" />
                </Link>

                <Link href="#" color="inherit" underline="none" mr={3}>
                  <img src={youtube} alt="youtube" />
                </Link> */}

                <Link href="https://www.facebook.com/happylifecontactcentre/" color="inherit" underline="none" target="_blank" rel="noopener noreferrer">
                  <img src={fb} alt="facebook" />
                </Link>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Divider sx={{
        '&.MuiDivider-root': {
          borderColor: '#000000',
          marginBottom: '1rem'
        }
      }} />

      <Grid container spacing={isMobile ? 1 : 5}>
        <Grid item xs={12} sm="auto">
          <Link color="inherit" underline="none">
            <TextSmall content="Happy Life Sri Lanka | 2024" color="#7C7C7C" />
          </Link>
        </Grid>
        <Grid item xs={12} sm="auto" sx={{
              '&.MuiGrid-root': {
                display: !isMobile ? 'flex' : '',
                alignItems: !isMobile ? 'flex-start' : '',
              }
            }}>
          <>
          <TextSmall content="Designed & Developed by" color="#7C7C7C" />
          <Link sx={{
            display: !isMobile ? 'flex' : '',
            alignItems: !isMobile ? 'flex-start' : '',
          }}
           ml={1} href="https://encyte.io/" color="inherit" underline="none" className="para-text" target="_blank" rel="noopener noreferrer">
            <TextSmall content="ENCYTE" color="#7C7C7C" />
          </Link>
          </>
        </Grid>
      </Grid>
    </div >
  )
}

export default Footer